import { CSSProperties, useEffect, useMemo, useState } from "react"
import API from "./API"
import { AdminQueryCompany } from "../../backend/src/api/dto"
import { Link } from "react-router"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DndContext, KeyboardSensor, MouseSensor, TouchSensor, closestCenter, type DragEndEvent, type UniqueIdentifier, useSensor, useSensors } from '@dnd-kit/core'
import { restrictToVerticalAxis } from '@dnd-kit/modifiers'
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

function Companies() {

    const [data, setData] = useState<AdminQueryCompany[]>([])

    useEffect(() => {
        API.getCompanies().then(res => {
            setData(res)
        })
    }, [])

    function handleDragEnd(event: DragEndEvent) {
        const { active, over } = event
        console.log({ active, over });
        if (active && over && active.id !== over.id) {
            setData(data => {
                const oldIndex = data.findIndex(item => 'company-' + item.companyId === active.id)
                const newIndex = data.findIndex(item => 'company-' + item.companyId === over.id)
                const newArray = arrayMove(data, oldIndex, newIndex);
                API.sortOrder('company', newArray.map(item => item.companyId));
                return newArray
            })
        }
    }

    const sensors = useSensors(
        useSensor(MouseSensor, {}),
        useSensor(TouchSensor, {}),
        useSensor(KeyboardSensor, {})
    )

    const dataIds = useMemo<UniqueIdentifier[]>(
        () => data?.map(({ companyId }) => 'company-' + companyId),
        [data]
    );

    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header" style={{ height: '55px' }}>
                    <div className="row">
                        <div className="col-6">
                            <h5 className="mt-2">
                                <FontAwesomeIcon fixedWidth icon={["fas", "building"]} /> Spoločnosti
                            </h5>
                        </div>
                        <div className="col-6 text-end">
                            <Link to="/dashboard/company/0" className="btn btn-success"><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} /> Pridať spoločnosť</Link>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <DndContext collisionDetection={closestCenter} modifiers={[restrictToVerticalAxis]} onDragEnd={handleDragEnd} sensors={sensors}>
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th style={{ width: '50px' }}></th>
                                    <th style={{ width: '300px' }}>Meno</th>
                                    <th>Popis</th>
                                    <th className="text-center" style={{ width: '110px' }}>Stav</th>
                                    <th className="text-center" style={{ width: '110px' }}>Akcia</th>
                                </tr>
                            </thead>
                            <tbody>
                                <SortableContext items={dataIds} strategy={verticalListSortingStrategy}>
                                    {
                                        data.map(company => {
                                            return (
                                                <DraggableRow key={'company-' + company.companyId} company={company} />
                                            )
                                        })
                                    }
                                </SortableContext>
                            </tbody>
                        </table>
                    </DndContext>
                </div>
            </div>
        </div>
    )
}


function DraggableRow({ company }: { company: AdminQueryCompany }) {
    const { transform, transition, setNodeRef, isDragging, attributes, listeners } = useSortable({
        id: 'company-' + company.companyId,
    })

    const style: CSSProperties = {
        transform: CSS.Transform.toString(transform),
        transition: transition,
        opacity: isDragging ? 0.8 : 1,
        zIndex: isDragging ? 1 : 0,
        position: 'relative',
    }
    return (
        <tr ref={setNodeRef} style={style}>
            <td className="text-center">
                <div {...attributes} {...listeners}>
                    <FontAwesomeIcon fixedWidth icon={["fas", "grip-vertical"]} />
                </div>
            </td>
            <td>{company.name}</td>
            <td>{company.description}</td>
            <td className="text-center">{company.status ? <span className="text-success">Aktívna</span> : <span className="text-danger">Neaktívna</span>}</td>
            <td className="text-center"><Link className="btn btn-primary btn-sm" to={"/dashboard/company/" + company.companyId}><FontAwesomeIcon fixedWidth icon={["fas", "pen"]} /> Upraviť</Link></td>
        </tr>

    )
}


export default Companies